import { config } from "../../config";
const response = await fetch(`${process.env.PUBLIC_URL}/config.json`);
const keys = await response.json();

const endPoint = {
  summary: "/anomaly/finding_occurrences/summary",
  scopedFindingRule: "/anomaly/scoped_finding_rule/",
  signals: "/anomaly/signal/",
  anomalyType: "/anomaly/anomaly_type/",
  anomalyRule: "/anomaly/anomaly_rule/",
  scopedAnomalyRule: "/anomaly/scoped_anomaly_rule/",
  recommendation: "/anomaly/recommendation/",
  findingRule: "/anomaly/finding_rule/",
  findingField: "/anomaly/finding_field",
  scopeList: "/anomaly/scoped_finding_rule/",
  recommendationUpdate: "/anomaly/prioritized_suggestion/",
  machineType: "/meta/machine/types",
  customerType: "/meta/customer",
  factoryType: "/meta/plant",
  serialNumberType: "/meta/machine",
  selectScopedAnomalyRuleType: "/anomaly/scoped_anomaly_rule/",
  machineHMI: "/anomaly/machine_hmi",
  machineNode: "/anomaly/machine_node",
  machineFunction: "/anomaly/machine_function"
};

export const header = {
  "Ocp-Apim-Subscription-Key": keys.REACT_APP_API_SUBSCRIPTION_KEY,
  "Access-Control-Allow-Origin": "*",
};

export const params = {
  id: config.id,
  tid: config.tenantId,
  lang: window.sessionStorage.getItem("language_code")
    ? window.sessionStorage.getItem("language_code")
    : "en",
};

export const machineAPI = endPoint.summary;
export const scopedFindingRuleAPI = endPoint.scopedFindingRule;
export const signalsAPI = endPoint.signals;
export const anomalyTypeAPI = endPoint.anomalyType;
export const anomalyRuleAPI = endPoint.anomalyRule;
export const scopedAnomalyRuleAPI = endPoint.scopedAnomalyRule;
export const recommendationListAPI = endPoint.recommendation;
export const findingRuleAPI = endPoint.findingRule;
export const findingFieldAPI = endPoint.findingField;
export const recommendationUpdateAPI = endPoint.recommendationUpdate;
export const machineTypeAPI = endPoint.machineType;
export const customerTypeAPI = endPoint.customerType;
export const factoryTypeAPI = endPoint.factoryType;
export const serialNumberTypeAPI = endPoint.serialNumberType;
export const scopeListAPI = endPoint.scopeList;
export const selectScopedAnomalyRuleAPI = endPoint.selectScopedAnomalyRuleType;
export const machineHMIAPI = endPoint.machineHMI;
export const machineNodeAPI = endPoint.machineNode;
export const machineFunctionAPI = endPoint.machineFunction;

